import { render, staticRenderFns } from "./LoginShortCuts.vue?vue&type=template&id=6147ef7e&"
import script from "./LoginShortCuts.vue?vue&type=script&lang=js&"
export * from "./LoginShortCuts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports